export default __webpack_public_path__ + "static/media/sc22.a75d8e0a.jpg";